import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { useState } from 'react';

import { Util } from '../../common/util/util';

export const fetchCatalog = createAsyncThunk(
  'catalog/fetchAll',
  async (_: { slug: string; catalogType: string }, thunkApi) => {
    try {
      const dataResponce = await axios({
        method: 'get',
        baseURL: process.env.REACT_APP_BASE_URL_API,
        url: `/api/${_.catalogType}-catalog/${_.slug}`,
        headers: {
          token: Util.getTokenSecurity(),
        },
      });
      return thunkApi.fulfillWithValue(dataResponce.data.catalog);
    } catch (error) {
      if (error instanceof Error) {
        return thunkApi.rejectWithValue(error.message);
      } else {
        return thunkApi.rejectWithValue('Loading Error');
      }
    }
  }
);

export const fetchCatalogItems = createAsyncThunk(
  'catalog-items/fetchSome',
  async (
    _: {
      slug: string;
      taxonomy_type: string;
      offset: number;
      priceKopecksMin: number | undefined;
      priceKopecksMax: number | undefined;
      availability: boolean;
      selectSort: string;
    },
    thunkApi
  ) => {
    try {
      const dataResponce = await axios({
        method: 'get',
        baseURL: process.env.REACT_APP_BASE_URL_API,
        url: `/api/catalog-items`,
        headers: {
          token: Util.getTokenSecurity(),
        },
        params: {
          taxonomy_slug: _.slug,
          taxonomy_type: _.taxonomy_type,
          price_kopecks_min: _.priceKopecksMin ? _.priceKopecksMin - 1 : -1,
          price_kopecks_max: _.priceKopecksMax
            ? _.priceKopecksMax + 1
            : 3000000,
          limit: 30,
          offset: _.offset,
          availability: _.availability ? 'availability' : 'no',
          sort: _.selectSort,
        },
      });
      return thunkApi.fulfillWithValue(dataResponce.data.catalog_items);
    } catch (error) {
      if (error instanceof Error) {
        return thunkApi.rejectWithValue(error.message);
      } else {
        return thunkApi.rejectWithValue('Loading Error');
      }
    }
  }
);
